/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellModelExport } from "./CellModelExport";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var DateTimeCellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeCellModelExport, _super);
    function DateTimeCellModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.af = new Date();
        _this.ag = 0;
        _this.ae = false;
        return _this;
    }
    DateTimeCellModelExport.prototype.get_ac = function () {
        return "DateTimeCell";
    };
    DateTimeCellModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
        a.l("dateTimeFormat : " + this.ag + ", ");
    };
    DateTimeCellModelExport.$t = markType(DateTimeCellModelExport, 'DateTimeCellModelExport', CellModelExport.$);
    return DateTimeCellModelExport;
}(CellModelExport));
export { DateTimeCellModelExport };
//# sourceMappingURL=DateTimeCellModelExport.js.map
